/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

import { getSaleType } from 'pages/MyAccount/utils/orders';
import ShipmentHeader from '../ShipmentHeader';
import Products from '../Products';
import styles from './styles.module.scss';

const DesktopProductList = ({ shipped, pending, dropship, trackShipment }) => (
  <section className={styles['product-list']} data-testid="desktop-items">
    {shipped.map((shipment, index) => (
      <div key={index} className={styles.shipment}>
        <ShipmentHeader
          title={`Shipment ${index + 1}`}
          subtitle={getSaleType(shipment)}
          shipmentDetails={shipment.shipmentDetails}
          trackShipment={trackShipment}
        />
        <Products products={shipment.products} />
      </div>
    ))}
    {pending.map((shipment, index) => (
      <div key={index} className={styles.shipment}>
        <ShipmentHeader
          title="Pending Shipment"
          subtitle={getSaleType(shipment)}
          shipmentDetails={shipment.shipmentDetails}
          trackShipment={trackShipment}
        />
        <Products products={shipment.products} />
      </div>
    ))}
    {dropship.map((shipment, index) => (
      <div key={index} className={styles.shipment}>
        <ShipmentHeader
          title="Drop Ship"
          subtitle={getSaleType(shipment)}
          shipmentDetails={shipment.shipmentDetails}
          trackShipment={trackShipment}
        />
        <Products products={shipment.products} />
      </div>
    ))}
  </section>
);

DesktopProductList.propTypes = {
  shipped: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pending: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dropship: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  trackShipment: PropTypes.func.isRequired,
};

export default DesktopProductList;
